import React from "react";
import "./why-trust-us.css";

const WhyTrustUs = () => {
  const reasons = [
    { icon: "👔", title: "Trusted Expertise", desc: "Our team has years of experience guiding clients to financial success." },
    { icon: "🔒", title: "Secure Platform", desc: "Your data and funds are protected with top-notch security protocols." },
    { icon: "📊", title: "Transparent Insights", desc: "We provide clear reports and insights so you always know where you stand." },
    { icon: "🕒", title: "24/7 Support", desc: "Our experts are always available to assist you whenever needed." },
  ];

  return (
    <section className="wtu-section">
      <div className="wtu-left">
        <div className="wtu-icons-container">
          {reasons.map((r, i) => (
            <div key={i} className={`wtu-icon-circle wtu-icon-${i + 1}`} aria-label={r.title} title={r.title}>
              <span className="wtu-icon">{r.icon}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="wtu-right">
        <h2>Why Trust Us?</h2>
        <div className="wtu-reason-list">
          {reasons.map((r, i) => (
            <div key={i} className="wtu-reason-item">
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyTrustUs;
